import * as fuzzyblobs from './fuzzy-blobs'
import * as m4 from './m4'
import * as palette from './colors'

import anime from 'animejs/lib/anime.es.js'

fuzzyblobs.init('.js-FuzzyBlobs', {
    instance_count: 4,
    user_update: function(mat, col, index, width, height, count) {
        let colors = [
            palette.pink01,
            palette.purple01,
            palette.green01,
            palette.yellow01,
        ];

        let angle = (index / count) + performance.now() * 0.000025;

        let w = height * 0.40;
        let h = height * 0.40;

        let x = Math.cos(angle * Math.PI * 2.0) * (w * 0.425);
        let y = Math.sin(angle * Math.PI * 2.0) * (h * 0.425) + height * 0.30;

        m4.identity(mat);
        m4.translation([width * 0.5 + x, height * 0.5 + y, 0], mat);
        m4.scale(mat, [w, h, 1], mat);
        m4.axisRotate(mat, [0.0, 0.0, 1.0], performance.now() * 0.001 * (0.1 + 0.1 * index), mat);

        let color = colors[index % colors.length];
        col[0] = color[0];
        col[1] = color[1];
        col[2] = color[2];
        col[3] = color[3];
    }
});


// @TODO(Grey): Measure the text and generate these frames with the offsets
// so that it is more resiliant to layout changes, can also animate the width
// so as to avoid sentence gaps for shorter words

function text_flipper_init() {
    var root = document.querySelector('.js-TextFlipper');

    function addWords() {
        let words = ["Unlock", "Engage", "Celebrate"];
        for (let i = 0; i < words.length; i += 1) {
            let word = document.createElement('span');
            let br = document.createElement('br');
            let text = document.createTextNode(words[i]);

            word.appendChild(text);
            word.classList.add('js-TextFlipper-word', 'l-inlineBlock');

            root.appendChild(br);
            root.appendChild(word);
        }
    }

    function scrollAnimation(words) {
        let scrollKeyframes = [];

        for (let i = 1; i < words.length; i += 1) {
            scrollKeyframes.push({
                'translateY': (-1.25 * i) + 'em',
                delay: 2000,
                duration: 600,
            });
        }

        scrollKeyframes.push({
            'translateY': 0,
            delay: 2000,
            duration: 600,
        });

        anime({
            targets: root,
            keyframes: scrollKeyframes,
            loop: true,
        });
    }

    function widthAnimation(words) {
        let baseFontSize = parseFloat(getComputedStyle(root.parentElement.parentElement).fontSize) || 16;
        let widthKeyframes = [];

        for (let i = 1; i < words.length; i += 1) {
            widthKeyframes.push({
                'width': (words[i].getBoundingClientRect().width / baseFontSize) + 'em',
                delay: 2000,
                duration: 600,
            });
        }

        widthKeyframes.push({
            'width': (words[0].getBoundingClientRect().width / baseFontSize) + 'em',
            delay: 2000,
            duration: 600,
        });

        root.parentElement.style.width = (words[0].getBoundingClientRect().width / baseFontSize) + 'em';

        anime({
            targets: root.parentElement,
            keyframes: widthKeyframes,
            loop: true,
        });
    }


    addWords();
    var words = root.querySelectorAll('.js-TextFlipper-word')
    scrollAnimation(words);
    widthAnimation(words);
}

window.addEventListener('load', function() {
    var root = document.querySelector('.js-TextFlipper');
    if (root) {
        text_flipper_init();
    }
});

